import { Component, ElementRef, Input, OnChanges, OnDestroy } from '@angular/core';
// Build "light": não executa expressions do Lottie (que rodam via eval). O arquivo vem de upload do usuário.
import lottie, { AnimationItem } from 'lottie-web/build/player/lottie_light';

@Component({
  selector: 'app-lottie-preview',
  template: '',
  styles: [
    ':host { display: block; width: 100%; max-width: 240px; aspect-ratio: 9 / 16; background: #f3f4f6; border-radius: 8px; overflow: hidden; }'
  ]
})
export class LottiePreviewComponent implements OnChanges, OnDestroy {
  @Input() animationData: object | null = null;

  private animation?: AnimationItem;

  constructor(private readonly host: ElementRef<HTMLElement>) {}

  ngOnChanges(): void {
    this.animation?.destroy();
    this.animation = undefined;
    if (!this.animationData) return;
    this.animation = lottie.loadAnimation({
      container: this.host.nativeElement,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: this.animationData
    });
  }

  ngOnDestroy(): void {
    this.animation?.destroy();
  }
}
